import React from "react";
import { StyleProp, StyleSheet, TextInput, TextInputProps, TextStyle, View } from "react-native";

import { PdSearch } from "src/components/Icons";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";

export const PdSearchInput = React.forwardRef<
  TextInput,
  TextInputProps & { contentContainerStyle?: StyleProp<TextStyle> }
>(({ contentContainerStyle, style, ...rest }, ref) => {
  return (
    <View style={[styles.pdSearchInputContainer, style]}>
      <View style={styles.pdSearchInputIconContainer}>
        <PdSearch style={styles.pdSearchInputIcon} />
      </View>
      <TextInput
        style={[styles.pdSearchInputTextInput, contentContainerStyle]}
        placeholderTextColor={kColors.gray500}
        ref={ref}
        placeholder="Search"
        {...rest}
      />
    </View>
  );
});

const styles = StyleSheet.create({
  pdSearchInputContainer: {
    alignItems: "center",
    borderColor: kColors.grayPink,
    borderRadius: kStyleConst.kSpacing,
    borderWidth: 1,
    flexDirection: "row",
    paddingHorizontal: kStyleConst.kSpacing * 2,
  },
  pdSearchInputIcon: {
    color: kColors.brand500,
    height: 16,
    width: 16,
  },
  pdSearchInputIconContainer: {
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100%",
    paddingRight: kStyleConst.kSpacing * 2,
  },
  pdSearchInputTextInput: {
    color: kColors.brand500,
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: "300",
    height: 34,
    letterSpacing: 1.2,
    width: "100%",
  },
});
